var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionsRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ef5c69",
    d: "M15.188 3.375h-2.813v-.562a1.687 1.687 0 0 0-1.687-1.688H7.312a1.687 1.687 0 0 0-1.687 1.688v.562H2.813a.563.563 0 1 0 0 1.125h.562v10.125A1.125 1.125 0 0 0 4.5 15.75h9a1.125 1.125 0 0 0 1.125-1.125V4.5h.563a.562.562 0 1 0 0-1.125M6.75 2.813a.563.563 0 0 1 .563-.563h3.375a.56.56 0 0 1 .562.563v.562h-4.5zm6.75 11.812h-9V4.5h9zM7.875 7.313v4.5a.562.562 0 1 1-1.125 0v-4.5a.563.563 0 1 1 1.125 0m3.375 0v4.5a.562.562 0 1 1-1.125 0v-4.5a.563.563 0 0 1 1.125 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsRemove);
export default __webpack_public_path__ + "static/media/actions-remove.df55de9307966af3c56725dd501c1d17.svg";
export { ForwardRef as ReactComponent };